<template>
    <div :class="{ 'modal': true, 'active': showModal }">

        <div class="modal-content">

            <div class="modal-content-header">
                <h3 v-if="item.id">
                    {{ $t('label.editService') }}
                </h3>
                <h3 v-else>
                    {{ $t('label.addService') }}
                </h3>
                <span class="modal-content-header-close" @click.prevent="close(false)">
                    <i aria-hidden="true" class="icon icon-close-large"></i>
                </span>
            </div>
            <div class="modal-content-body">
                <form action="#" class="form" @submit.prevent>
                    <div class="row">
                        <div class="col-lg-12">
                            <input-widget
                                    :label="$t('label.name')"
                                    :placeholder="$t('label.name')"
                                    :type="'text'"
                                    v-model="item.name"
                                    validate="required"
                                    ref="focus">
                            </input-widget>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="row">
                                <div class="col-lg-12">
                                    <label for="duration">{{ $t('label.duration') }}</label>
                                    <div class="select">
                                        <select name="duration" id="duration" v-model="item.duration">
                                            <option v-for="minutes in durationMinutes" :value="minutes" :selected="item.duration">
                                                <span v-if="hour(minutes)">{{ hour(minutes)+$t('label.h') }}</span> <span v-if="minute(minutes)">{{ minute(minutes)+$t('label.min') }}</span>
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <label for="pause">{{ $t('label.pause') }}</label>
                                    <div class="select">
                                        <select name="pause" id="pause" v-model="item.pause">
                                            <option value="0" :selected="item.pause">{{ $t('label.noPause') }}</option>
                                            <option v-for="minutes in pauseMinutes" :value="minutes">
                                                <span v-if="hour(minutes)">{{ hour(minutes)+$t('label.h') }}</span> <span v-if="minute(minutes)">{{ minute(minutes)+$t('label.min') }}</span>
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <input-widget
                                            :label="$t('label.price') + ' (' + currency.toUpperCase() + ')'"
                                            :type="'number'"
                                            v-model="item.price"
                                            validate="required"
                                    >
                                    </input-widget>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="button-wrapper-right margin-bottom-20">
                                <input type="submit" :value="$t('button.save')" :class="{'button-full': true, 'loading': loading}" @click.prevent="validate" />
                                <span class="button-hollow" @click.prevent="close(false)">{{ $t('button.cancel') }}</span>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

    </div>
</template>

<script>
  import InputWidget from '@/components/widgets/InputWidget'
  import ColorPickerWidget from '@/components/widgets/ColorPickerWidget'
  import auth from '@/auth'
  import _ from 'lodash'
  //  import Vue from 'vue'
  export default {
    name: 'ServiceModal',
    components: {InputWidget, ColorPickerWidget},
    props: ['data', 'show', 'table'],
    data () {
      return {
        showModal: false,
        item: {
          name: null,
          duration: 0.25,
          price: 0,
          pause: 0
        },
        durationMinutes: [],
        pauseMinutes: [],
        loading: false,
        currency: auth.getUser().personal.organization.currency
      }
    },
    created () {
      this.durationMinutes = this.prepareMinutes(180)
      this.pauseMinutes = this.prepareMinutes(105)
    },
    watch: {
      show (value) {
        this.showModal = value
        if (value) {
          setTimeout(() => {
            this.$refs.focus.$el.querySelector('input').focus()
          }, 500)
        }
      },
      data (value) {
        this.item = value
        this.item.duration = this.item.duration * 60
        this.item.pause = this.item.pause * 60
      }
    },
    methods: {
      validate () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.save()
          }
        })
      },
      save () {
        this.loading = true
        let item = _.clone(this.item)
        item.duration = item.duration / 60
        item.pause = item.pause / 60
        if (!this.item.id) {
          this.$api.post('/v1/services', item).then(() => {
            this.close(true)
            this.loading = false
            this.$events.fire('message-open', {
              type: 'success',
              message: this.$t('message.saveSuccess')
            })
            this.table.reload()
          }).catch(() => {
            this.loading = false
            this.$events.fire('message-open', {
              type: 'error',
              message: this.$t('message.saveFailed')
            })
          })
        } else {
          this.$api.post('/v1/services/' + item.id, item).then(() => {
            this.close(true)
            this.loading = false
            this.$events.fire('message-open', {
              type: 'success',
              message: this.$t('message.saveSuccess')
            })
            this.table.reload()
          }).catch(() => {
            this.loading = false
            this.$events.fire('message-open', {
              type: 'error',
              message: this.$t('message.saveFailed')
            })
          })
        }
      },
      prepareMinutes (n) {
        let minutes = []
        let j = 0
        for (let i = 15; i <= n; i += 15) {
          minutes[j] = i
          j++
        }
        return minutes
      },
      minute (val) {
        return val % 60
      },
      hour (val) {
        return parseInt(val / 60)
      },
      close (updated) {
        this.item = {}
        this.showModal = false
        this.$events.fire('service-closed', {
          show: this.showModal,
          updated: updated
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/pages/Organization/Settings/Services/ServiceModal.vue